export default {
  SET_SLOT_SWITCHER_INDEX(state, payload) {
    state.slotSwitcherIndex = payload
  },
}
